import { Dto, DtoWithId } from "@mango/core";
import { VerzendTarieven } from "./verzend-tarieven";


@Dto({fullName: "CIJBorculo.Logic.VerzendTarievenPrijzen"})
export class VerzendTarievenPrijzen extends DtoWithId {
	verzendTarief: VerzendTarieven;
	prijs: number;
	datum: Date;
}